export default {"src":"/_next/static/media/mage_file-2-fill.1775ec2e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};